module.exports = __webpack_public_path__ + "static/img/智能手工课堂1.3c8dd2f2.png";